import { Component, OnInit } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-administration',
    templateUrl: './administration.component.html',
    styleUrls: ['./administration.component.scss'],
    imports: [RouterModule, RouterOutlet]
})
export class AdministrationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
